import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.deleteConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: _vm.color,
        emit: 'delete'
      }],
      "showSelect": _vm.isActility,
      "checkBoxLable": _vm.$i18n_t('NiotaClassic.Devices.deleteFromActility'),
      "color": _vm.color
    },
    on: {
      "cancel": _vm.closeDeletePrompt,
      "delete": _vm.deleteItem,
      "is-selectecd": _vm.deleteFromRemote
    }
  }), _c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "click:clear": function ($event) {
        return _vm.updateSearchParams('');
      }
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "single-select": false,
      "show-select": "",
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "expanded": _vm.expanded,
      "show-expand": ""
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination],
      "input": function ($event) {
        return _vm.enterSelect($event);
      },
      "click:row": _vm.handleClickDevice,
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function ({
        headers,
        item
      }) {
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [_vm._v("\n        " + _vm._s(item.description === null ? _vm.$i18n_t('Common.noDescription') : `${_vm.$i18n_t('Common.description')}: ${item.description}`) + "\n      ")])];
      }
    }, {
      key: "item.selected",
      fn: function ({
        item
      }) {
        return [_c(VCheckbox, {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": item.selected
          }
        })];
      }
    }, {
      key: "item.image",
      fn: function ({
        item
      }) {
        return [_c(VAvatar, {
          attrs: {
            "color": _vm.color,
            "size": "30"
          }
        }, [item.deviceType && item.deviceType.image ? _c('img', {
          staticStyle: {
            "width": "30px",
            "height": "auto"
          },
          attrs: {
            "src": _vm.niota1ImageUrl(item.deviceType.image)
          }
        }) : item.deviceTypeImage ? _c('img', {
          staticStyle: {
            "width": "30px",
            "height": "auto"
          },
          attrs: {
            "src": _vm.niota1ImageUrl(item.deviceTypeImage)
          }
        }) : _c(VIcon, {
          staticClass: "c-icon",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor-on")])], 1)];
      }
    }, {
      key: "item.id",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v(_vm._s(item.id))])];
      }
    }, {
      key: "item.title",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          attrs: {
            "title": item.title
          }
        }, [_c('router-link', {
          attrs: {
            "to": `/niota-classic/devices/${item.id}/details`
          }
        }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1)];
      }
    }, {
      key: "item.eui",
      fn: function ({
        item
      }) {
        return [_vm.isCopySupported() ? _c('div', {
          staticClass: "euiElement",
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard($event, item.eui);
            }
          }
        }, [_c('pre', [_vm._v(_vm._s(item.eui))]), _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-copy")])], 1) : _c('div', {
          staticClass: "euiElement"
        }, [_c('pre', [_vm._v(_vm._s(item.eui))])])];
      }
    }, {
      key: "item.originator",
      fn: function ({
        item
      }) {
        return [item.originator ? _c('span', [_vm._v(_vm._s(item.originator.title))]) : _c('span', [_vm._v(_vm._s(item.originatorTitle))])];
      }
    }, {
      key: "item.operationalStatus",
      fn: function ({
        item
      }) {
        return [item.properties && item.properties.operational_status ? _c('span', [_vm._v("\n        " + _vm._s(_vm.getStatus(item.properties.operational_status)) + "\n      ")]) : _vm._e()];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('edit-item', item);
            }
          }
        }, [_vm._v("\n        fal fa-" + _vm._s(_vm.isIotHubManager ? 'edit' : 'eye') + "\n      ")]), _vm._v("\n       \n      "), _vm.isIotHubManager ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDeletePrompt(item);
            }
          }
        }, [_vm._v("\n        fal fa-trash-alt\n      ")]) : _vm._e()];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };